'use client';

import Link from 'next/link';
import { useAuth } from '@/hooks/useAuth';
import { LogOut, User, Bell } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AppImage } from '@/components/common/AppImage';

export function Header() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="sticky top-0 z-30 border-b border-gray-100/50 bg-white/80 shadow-sm backdrop-blur-sm md:z-100">
      <div className="max-w-8xl mx-auto px-2 lg:px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <div className="ml-16 lg:ml-0">
              <Link href="/dashboard" className="flex items-center space-x-2">
                <span className="bg-gradient-to-r from-primary-600 to-accent-blue bg-clip-text text-lg font-bold text-transparent sm:text-xl">
                  Auction Chase
                </span>
              </Link>
            </div>
          </div>

          {user && (
            <div className="flex items-center space-x-2 sm:space-x-4">
              <button className="rounded-full bg-gray-50 p-1.5 text-gray-500 transition-colors hover:bg-gray-100 hover:text-primary-600 sm:p-2">
                <Bell className="h-4 w-4 sm:h-5 sm:w-5" />
              </button>

              <Link
                href="/dashboard/profile"
                className="flex items-center space-x-1 rounded-full bg-gradient-to-r from-primary-50 to-primary-100/50 px-2 py-1.5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md sm:space-x-2 sm:px-4 sm:py-2"
              >
                <div className="h-6 w-6 overflow-hidden rounded-full sm:h-8 sm:w-8">
                  {user.profilePicture ? (
                    <AppImage
                      src={user.profilePicture}
                      alt={user.name || ''}
                      shape="circle"
                      gradient
                      fallbackText={user.name || ''}
                    />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center rounded-full bg-gradient-to-r from-primary-500 to-accent-blue text-white">
                      <User className="h-3 w-3 sm:h-4 sm:w-4" />
                    </div>
                  )}
                </div>
                <span className="max-w-[80px] truncate text-xs font-medium text-gray-700 sm:max-w-full sm:text-sm">
                  {user.name}
                </span>
              </Link>

              <button
                onClick={handleLogout}
                className={cn(
                  'flex items-center space-x-1 rounded-full px-2 py-1.5 text-xs font-medium sm:space-x-2 sm:px-4 sm:py-2 sm:text-sm',
                  'bg-white text-gray-700 shadow-sm transition-all duration-300',
                  'hover:-translate-y-0.5 hover:bg-gray-50 hover:text-primary-600 hover:shadow-md'
                )}
              >
                <LogOut className="h-3 w-3 sm:h-4 sm:w-4" />
                <span className="hidden xs:inline">Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
